// Module
var code = "<template bindable=\"ropedimension\">\n    <div class=\"form-element\">\n      <label for=\"name\" t=\"general.name\"></label>\n      <input type=\"text\" name=\"name\" value.bind=\"ropedimension.Name\">\n    </div>\n</template>\n";
// Exports
export default code;